import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { isPicflowIOSApp } from '../../../lib/is-ios-app';
import { OnGetData } from '../../../services/dialog.service';
import { UpgradeBadgeComponent } from '../../../shared-extra/components/pro-tag/upgrade-badge.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';

@Component({
  selector: 'app-add-section-dialog',
  templateUrl: './add-section-dialog.component.html',
  styleUrls: ['./add-section-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, UpgradeBadgeComponent],
})
export class AddSectionDialogComponent implements OnGetData {
  dialogName = 'add-section';
  close: (...args) => void;
  gallery = signal<GalleryDto>(undefined);
  isPicflowIOSApp = isPicflowIOSApp();

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 60, spacingY: 40, hasSmallBottomPart: true };
  }

  onGetData(data: { gallery: GalleryDto }, close: (...args) => void): void {
    this.close = close;
    this.gallery.set(data.gallery);
  }

  addSection(type: string) {
    this.close(type);
  }
}
